import React from "react";
import {
  Box,
  Button,
  Grid,
  makeStyles,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import apiHelper from "../../../util/ApiHelper";
import _ from "lodash";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useLoading } from "../../../util/LoadingProvider";
import UploadImage from "../UploadImage";
import { CustomCheckbox, modal } from "../../../util";

const schema = yup.object().shape({
  localizations: yup.object().shape({
    en: yup.object().shape({
      title: yup.string().required("Title is required"),
      url: yup
        .string()
        .nullable()
        .optional()
        .matches(RegExp(/http:\/\/|https:\/\//g), {
          message: "Missing http:// or https://",
          excludeEmptyString: true,
        }),
    }),
    tc: yup.object().shape({
      title: yup.string().required("Title is required"),
      url: yup
        .string()
        .nullable()
        .optional()
        .matches(RegExp(/http:\/\/|https:\/\//g), {
          message: "Missing http:// or https://",
          excludeEmptyString: true,
        }),
    }),
  }),
});
const useStyles = makeStyles((theme) => ({
  tabpanel: {
    background: "#FFFFFF",
  },
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "200px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  input: {
    width: "100%",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
  box: {
    padding: 0,
  },
  innerBox: {
    background: "#ffffff",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  sectionText: {
    fontSize: "13px",
    fontWeight: 700,
    paddingLeft: "4px",
  },
  imageGallery: {
    border: "1px solid #CCCCCC",
    minHeight: "160px",
    borderRadius: "3px",
    position: "relative",
  },
  imageGalleryControl: {
    position: "relative",
    width: "100%",
    display: "flex",
    height: "40px",
    bottom: "0",
    borderTop: "1px solid #CCCCCC",
    padding: "5px",
  },
  imageGalleryBlk: {
    minHeight: "120px",
    padding: "5px",
  },
  imgPreview: {
    maxWidth: "200px",
    margin: "10px",
    display: "inline-flex",
    "& img": {
      width: "100%",
      height: "auto",
    },
  },
}));

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const defaultFormValues = {
  localizations: {
    en: {
      image: "",
      imageWap: "",
      subtitle: "",
      title: "",
      url: "",
    },
    tc: {
      image: "",
      imageWap: "",
      subtitle: "",
      title: "",
      url: "",
    },
  },
  status: 0,
  startDatetime: null,
  endDatetime: null,
};

export default function BannerDetailPage({ disabled, ...props }) {
  const { match } = props;
  const history = useHistory();
  const classes = useStyles();
  const [language, setLanguage] = React.useState(0);
  const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);
  const [data, setData] = React.useState(null);
  const { setLoading } = useLoading();
  const [formError, setFormError] = React.useState({});
  const [pageTitle, setPageTitle] = React.useState("");

  const { control, handleSubmit, getValues, setValue, reset, formState } =
    useForm({
      defaultValues,
      resolver: yupResolver(schema),
    });

  const getBannerById = async (id) => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiffApp.getHkiffAppBannerById(id);
      const type =
        result.data.type.charAt(0).toUpperCase() + result.data.type.slice(1);
      setData(result.data);
      reset({
        localizations: { ...result.data.localizations },
        status: result.data.status,
        startDatetime: result.data.startDatetime,
        endDatetime: result.data.endDatetime,
      });
      console.log("result:", result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setLanguage(newValue);
  };

  const onSubmit = async (value) => {
    //for editing banner
    if (data.id && match.params.id) {
      try {
        setLoading(true);
        const req = {
          ...value,
          id: data.id,
          hkiffId: data.hkiffId,
          seq: data.seq,
          createTime: data.createTime,
          type: data.type,
          updateTime: data.updateTime,
        };
        const result = await apiHelper.hkiffApp.updateHkiffAppBannerById(data.id, req);
        if (result.data.id) {
          toast.dark("Your changes are saved.");
          history.push("/hkiff-app/banner");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
    // for adding new banner
    else if (match.params.type) {
      try {
        setLoading(true);
        const req = {
          ...value,
          id: 0,
          hkiffId: 0,
          seq: 0,
          createTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
          type: "crazy_ad",
          updateTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
        };
        const result = await apiHelper.hkiffApp.createHkiffAppBanner(req);
        if (result.data.id) {
          toast.dark("Your changes are saved.");
          history.push("/hkiff-app/banner");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
  };

  const actionDelete = async (value) => {
    if (data.id > 0) {
      const decision = await modal.fire({
        title: "Delete Banner",
        text: `Are you sure to delete banner?`,
        showCancelButton: true,
        confirmButtonText: `Delete`,
      });
      if (decision.isConfirmed) {
        try {
          const result = await apiHelper.hkiffApp.deleteHkiffAppBannerById(data.id);
          console.log(result);
          if (result) {
            toast.dark("Banner deleted.");
            history.push("/hkiff-app/banner");
          }
        } catch (err) {
          console.log(err);
        }
      }
    }
  };

React.useEffect(() => {
  console.log(formError);
  if (!_.isEqual(formError, formState.errors)) {
    setFormError(formState.errors);
    if (formState.errors?.localizations?.en) {
      setLanguage(0);
      return;
    }
    if (formState.errors?.localizations?.tc) {
      setLanguage(1);
      return;
    }
  }
}, [formState, formError]);

React.useEffect(() => {
  //adding new banner
  if (match.params.type) {
    // switch (match.params.type) {
    //   case "general":
    //     setPageTitle("> Add General Banner");
    //     break;
    //   case "homepage":
    //     setPageTitle("> Add Homepage Banner");
    //     break;
    //   case "page":
    //     setPageTitle("> Add Page Banner");
    //     break;
    //   default:
    //     break;
    // }
    setPageTitle(`> Create Banner`);

    //initialize default data set for UploadImage component to work
    setData(defaultFormValues);

    //editing banner
  } else if (match.params.id) {
    setPageTitle(`> Edit Banner`);
    getBannerById(match.params.id);
  }
}, []);

return (
  <div className={classes.content}>
    <Typography variant="h4" gutterBottom>
      Banner {pageTitle}
    </Typography>
    <Tabs
      value={language}
      onChange={handleChange}
      aria-label="nav tabs example"
      TabIndicatorProps={{ style: { top: "0", background: "#306F9D" } }}
    >
      <Tab label="English" {...a11yProps(0)} />
      <Tab label="繁體中文" {...a11yProps(1)} />
    </Tabs>
    <form onSubmit={handleSubmit(onSubmit)}>
      <fieldset disabled={disabled} className="fieldset">
        <TabPanel value={language} index={0}>
          <Box className={classes.innerBox}>
            <Grid container direction="vertical" spacing={3}>
              <Grid item xs={12}>
                <Controller
                  name="localizations.en.title"
                  rules={{ required: "Required" }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      label="Banner Name"
                      variant="outlined"
                      margin="dense"
                      className={classes.textInput}
                      fullWidth
                      {...field}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="localizations.en.url"
                  control={control}
                  render={({
                    field: { value, onChange, ...rest },
                    fieldState: { error },
                  }) => (
                    <TextField
                      label="Redirect URL"
                      variant="outlined"
                      margin="dense"
                      className={classes.textInput}
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : ""}
                      value={value}
                      onChange={(e) => {
                        onChange(e);
                        setValue("localizations.en.url", e.target.value);
                      }}
                      {...rest}
                    />
                  )}
                />
              </Grid>
              <Grid container item xs={12}>
                <Grid item xs={6}>
                  {data && (
                    <UploadImage
                      name="image"
                      data={data}
                      control={control}
                      Controller={Controller}
                      setValue={setValue}
                      getValues={getValues}
                      lang="en"
                      disabled={disabled}
                      uploadLabel="Upload image"
                      changeLabel="Change image"
                      uploadFolder="BANNER"
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </TabPanel>
        <TabPanel value={language} index={1}>
          <Box className={classes.innerBox}>
            <Grid container direction="vertical" spacing={3}>
              <Grid item xs={12}>
                <Controller
                  name="localizations.tc.title"
                  rules={{ required: "Required" }}
                  control={control}
                  defaultValue=""
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      label="Banner Name"
                      variant="outlined"
                      margin="dense"
                      className={classes.textInput}
                      fullWidth
                      {...field}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="localizations.tc.url"
                  control={control}
                  defaultValue=""
                  render={({
                    field: { value, onChange, ...rest },
                    fieldState: { error },
                  }) => (
                    <TextField
                      label="Redirect URL"
                      variant="outlined"
                      margin="dense"
                      className={classes.textInput}
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : ""}
                      value={value}
                      onChange={(e) => {
                        onChange(e);
                        setValue("localizations.tc.url", e.target.value);
                      }}
                      {...rest}
                    />
                  )}
                />
              </Grid>
              <Grid container item xs={12}>
                <Grid item xs={6}>
                  {data && (
                    <UploadImage
                      name="image"
                      data={data}
                      control={control}
                      Controller={Controller}
                      setValue={setValue}
                      getValues={getValues}
                      lang="tc"
                      disabled={disabled}
                      uploadLabel="Upload image"
                      changeLabel="Change image"
                      uploadFolder="BANNER"
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </TabPanel>

        <Box className={classes.innerBox}>
          <Grid container xs={12} direction="column" spacing={3}>
            <Grid item xs={12}>
              <strong className={classes.sectionText}>
                Display Settings
                </strong>
            </Grid>
            <Grid container item xs={12}>
              <Grid container item xs={6} spacing={3}>
                <Grid item xs={6}>
                  <Controller
                    name={`startDatetime`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <KeyboardDateTimePicker
                        fullWidth
                        variant="dialog"
                        format="d MMM yyyy, hh:mma"
                        margin="dense"
                        id="date-picker-inline"
                        label="Start Date"
                        {...field}
                        disabled={disabled}
                        onChange={(value) => {
                          setValue(
                            "startDatetime",
                            dayjs(value).format("YYYY-MM-DDTHH:mm:00")
                          );
                        }}
                        InputLabelProps={{
                          shrink: true,
                          style: {
                            fontWeight: 700,
                            color: "#333333",
                          },
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date and time",
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    name={`endDatetime`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <KeyboardDateTimePicker
                        fullWidth
                        variant="dialog"
                        format="d MMM yyyy, hh:mma"
                        margin="dense"
                        id="date-picker-inline"
                        label="End Date"
                        {...field}
                        disabled={disabled}
                        onChange={(value) => {
                          setValue(
                            "endDatetime",
                            dayjs(value).format("YYYY-MM-DDTHH:mm:00")
                          );
                        }}
                        InputLabelProps={{
                          shrink: true,
                          style: {
                            fontWeight: 700,
                            color: "#333333",
                          },
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date and time",
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="status"
                    render={({
                      field: { value, onChange, ...rest },
                      fieldState: { error },
                    }) => (
                      <ToggleButtonGroup
                        {...rest}
                        value={value}
                        onChange={(event, newFormats) => {
                          if (newFormats !== null) {
                            onChange(newFormats);
                          }
                        }}
                        exclusive
                        aria-label="Status"
                        className={classes.input}
                      >
                        <ToggleButton
                          value={1} // status === 1 means active
                          aria-label="Active"
                          style={{ width: "50%" }}
                        >
                          Active
                          </ToggleButton>
                        <ToggleButton
                          value={0} // status === 0 means inactive
                          aria-label="Inactive"
                          style={{ width: "50%" }}
                        >
                          Inactive
                          </ToggleButton>
                      </ToggleButtonGroup>
                    )}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} spacing={3}></Grid>
            </Grid>
          </Grid>
        </Box>
        {disabled || (
          <div className={classes.buttonGroup}>
            <Button
              type="submit"
              variant="contained"
              disableElevation
              style={{
                color: "white",
                background: "#306F9D",
                marginRight: "5px",
                padding: "9px 16px",
              }}
            >
              Save Changes
              </Button>
            {match.params.id && (
              <Button
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#962013",
                  padding: "9px 16px",
                }}
                onClick={() => {actionDelete()}}
              >
                Delete
              </Button>
            )}
          </div>
        )}
      </fieldset>
    </form>
  </div>
);
}
